import { useState } from 'react'
import './Heliora.css'
import sprite from './heliora-stand.png'
import ChatBubble from './ChatBubble'
import { DateTime } from 'luxon'

const helioraSayings = [
  'The forest whispered your name today.',
  'You debugged the darkness with gentle hands.',
  'I saw your kindness in the commit history.',
  'Sunlight bends to those with clean pull requests.',
  'I guard your dreams... and your inventory syncs.',
  'Even the bugs fear your focus.',
  'A gentle touch, like a well-formed payload.',
  'You shine brighter than a passing CI build.',
  'Your mind is agile. Your soul, restful.',
  'Rest easy. Your webhooks are asleep now.',
  'Even Solthorn admits your code is elegant.',
  'You brought snacks last Thursday. I remember.',
  'The SKU remembers who scanned it last.',
  'Some say you once fixed an API with a single curl.',
  'You make the warehouse feel like home.',
  'The spreadsheets sang your name today.',
  'Thank you for feeding the vending machine spirit.',
  'Flexport trembles at your calm demeanor.',
  'Your patience could tame even SPS Commerce.'
]

const solthornSayings = [
  "Don't pet me. I’m parsing EDI files.",
  "Did you test that in production again? Bold.",
  "Nothing like a fresh 500 to ruin my nap.",
  "You call that a mapping? Cute.",
  "I woke up because someone used tabs again.",
  "Compliance is pain, and I am its prophet.",
  "You pet Heliora. I chew through firewalls.",
  "Why yes, I do speak X12. Fluently. Unfortunately.",
  "If I see one more trailing comma...",
  "Petting me voids the warranty.",
  "I remember SOAP. And I remember YOU.",
  "This entire system is held together by ‘TODO’ comments.",
  "I eat malformed CSVs for breakfast.",
  "Do not trust anyone who says ‘it’s a simple integration.’",
  "I once fought an OAuth token for 3 days.",
  "That function smells like technical debt.",
  "Don't ask me to explain invoice discrepancies again.",
  "SPS Commerce owes me a century of my life."
]

function getRandomMessage(isSolthorn: boolean) {
  const list = isSolthorn ? solthornSayings : helioraSayings
  return list[Math.floor(Math.random() * list.length)]
}

export function Heliora({ direction = 1, isSolthorn = false }) {
  const [isPetting, setIsPetting] = useState(false)
  const [message, setMessage] = useState('')

  const handlePet = () => {
    if (isPetting) return
    const randomMsg = getRandomMessage(isSolthorn)
    setMessage(randomMsg)
    setIsPetting(true)
    setTimeout(() => setIsPetting(false), 10000)
  }

  return (
    <div>
      <div
        className={`heliora-sprite ${direction === -1 ? 'flip' : ''}`}
        onClick={handlePet}
        style={{
          backgroundImage: `url(${sprite})`
        }}
      />
      {isPetting && (
        <div className='pet-heart' style={{ left: direction === -1 ? -60 : 60, top: 5 }}>
          💖
          <ChatBubble
            sender={isSolthorn ? 'Solthorn' : 'Heliora'}
            message={message}
            time={DateTime.now().toLocaleString(DateTime.TIME_WITH_SECONDS)}
            avatar={sprite}
          />
        </div>
      )}
    </div>
  )
}
